/**
 * How a workflow step's screen reads at a glance — shared by the legacy Workflow Screens
 * wizard's rail and the process editor's Forms tab, so a step that is a draft in one is
 * drawn the same way in the other.
 */
export type StepScreenState = "managed" | "unmanaged" | "draft" | "pending" | "none";

export interface IStepScreenStateIcon {
  /** Asset name under `public/images/common`. */
  name: string;
  /** Token, not a literal: the rail is drawn in both themes. */
  color: string;
  /** What the glyph means, for its `title`. */
  title: string;
}

/**
 * A monitor, colour-coded: blue when Forms manages the screen, steel when an existing screen
 * was assigned, red when none is bound. Work that has not been applied yet shows a clock.
 */
export const STEP_SCREEN_STATE_ICON: Record<StepScreenState, IStepScreenStateIcon> = {
  managed: { name: "screen-share", color: "var(--blue-6)", title: "Managed screen" },
  unmanaged: {
    name: "screen-share",
    color: "var(--dark-9)",
    title: "Unmanaged screen (assigned, not generated here)"
  },
  draft: { name: "clock", color: "var(--orange-6)", title: "Draft screen — not applied yet" },
  pending: { name: "clock", color: "var(--orange-6)", title: "Existing screen pending — links on Apply Screens" },
  none: { name: "screen-share", color: "var(--red-5)", title: "No screen yet" }
};
